// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%271em%27 height=%271em%27 viewBox=%270 0 16 16%27 class=%27bi bi-caret-left-fill%27 fill=%27currentColor%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M3.86 8.753l5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%271em%27 height=%271em%27 viewBox=%270 0 16 16%27 class=%27bi bi-caret-right-fill%27 fill=%27currentColor%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
 * Based on: https://gist.github.com/miwahall/7028640
 * And the idea of gordon-matt
 *
 * Works with Bootstrap 5.0.0-beta2, the Icons used are also new Bootstrap Svg Icon set (1.3.0)
 * The final design isn't 110% perfect.
 *
 * Used libs:
 * 
 * jquery-3.5.1.min.js
 * jquery-ui.min.js	(1.12.1)
 * bootstrap.min.cs	(5.0.0-beta2)
 * bootstrap.min.js	(5.0.0-beta2)
 * bootstrap-icons.css	(1.3.0)
 */

.ui-datepicker {
  background-color: #fff;
  border: none;
  border-radius: 6px;
  box-shadow: 0 0 8px rgba(150, 150, 150, .6);
  display: none;
  margin-top: 4px;
  padding: 10px;
  width: 240px;
}

.ui-datepicker a,
.ui-datepicker a:hover {
  text-decoration: none;
}

.ui-datepicker a:hover,
.ui-datepicker td:hover a {
  color: #e5bd54;
  -webkit-transition: color 0.1s ease-in-out;
  -moz-transition: color 0.1s ease-in-out;
  -o-transition: color 0.1s ease-in-out;
  transition: color 0.1s ease-in-out;
}

.ui-datepicker .ui-datepicker-header {
  margin-bottom: 4px;
  text-align: center;
  border-radius: 4px;
  padding: 2px;
}

.ui-datepicker .ui-datepicker-title {
  font-weight: 700;
}

.ui-datepicker .ui-datepicker-prev,
.ui-datepicker .ui-datepicker-next {
  cursor: pointer;
  -webkit-font-smoothing: antialiased;
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: normal;
  height: 26px;
  line-height: 1;
  width: 30px;
}

.ui-datepicker .ui-datepicker-prev-hover:hover,
.ui-datepicker .ui-datepicker-next-hover:hover{
    border-radius: 4px;
    background-color: #eee;
  }

.ui-datepicker .ui-datepicker-prev {
  float: left;
  text-align: left;
  padding-left: 7px;
}

.ui-datepicker .ui-datepicker-next {
  float: right;
  text-align: right;
  padding-right: 7px;
}

.ui-datepicker .ui-icon {
  display: none;
}

.ui-datepicker .ui-datepicker-calendar {
  table-layout: fixed;
  width: 100%;
}

.ui-datepicker .ui-datepicker-calendar th,
.ui-datepicker .ui-datepicker-calendar td {
  text-align: center;
  padding: 4px 0;
}

.ui-datepicker .ui-datepicker-calendar td {
  border-radius: 4px;
  -webkit-transition: background-color 0.1s ease-in-out, color 0.1s ease-in-out;
  -moz-transition: background-color 0.1s ease-in-out, color 0.1s ease-in-out;
  -o-transition: background-color 0.1s ease-in-out, color 0.1s ease-in-out;
  transition: background-color 0.1s ease-in-out, color 0.1s ease-in-out;
}

.ui-datepicker .ui-datepicker-calendar td:hover {
  background-color: #eee;
  cursor: pointer;
}

.ui-datepicker .ui-datepicker-calendar td a {
  text-decoration: none;
}

.ui-datepicker .ui-datepicker-current-day {
  background-color: #e5bd54;
}

.ui-datepicker .ui-datepicker-current-day a {
  color: #fff;
}


.ui-datepicker .ui-datepicker-calendar .ui-datepicker-unselectable {
  background-color: #eff0f1;
  cursor: default;
}

.ui-datepicker .ui-datepicker-calendar .ui-datepicker-unselectable:hover {
  background-color: #eff0f1;
  cursor: default;
}


.ui-datepicker-prev span {
  display: none;
}

.ui-datepicker-prev::before {
  display: inline-block;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 1rem 1.5rem;
  width: 1rem;
  height: 1.7rem;
}

.ui-datepicker-next::after {
  display: inline-block !important;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: 1rem 1.5rem;
  width: 1rem;
  height: 1.7rem;
}`, "",{"version":3,"sources":["webpack://./assets/css/jquery-bootstrap-datepicker.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,eAAe;EACf,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,0CAA0C;EAC1C,uCAAuC;EACvC,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,mCAAmC;EACnC,sCAAsC;EACtC,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,WAAW;AACb;;AAEA;;IAEI,kBAAkB;IAClB,sBAAsB;EACxB;;AAEF;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6EAA6E;EAC7E,0EAA0E;EAC1E,wEAAwE;EACxE,qEAAqE;AACvE;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,yDAAgU;EAChU,4BAA4B;EAC5B,4BAA4B;EAC5B,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,yDAAmU;EACnU,4BAA4B;EAC5B,4BAA4B;EAC5B,WAAW;EACX,cAAc;AAChB","sourcesContent":["/* \n * Based on: https://gist.github.com/miwahall/7028640\n * And the idea of gordon-matt\n *\n * Works with Bootstrap 5.0.0-beta2, the Icons used are also new Bootstrap Svg Icon set (1.3.0)\n * The final design isn't 110% perfect.\n *\n * Used libs:\n * \n * jquery-3.5.1.min.js\n * jquery-ui.min.js\t(1.12.1)\n * bootstrap.min.cs\t(5.0.0-beta2)\n * bootstrap.min.js\t(5.0.0-beta2)\n * bootstrap-icons.css\t(1.3.0)\n */\n\n.ui-datepicker {\n  background-color: #fff;\n  border: none;\n  border-radius: 6px;\n  box-shadow: 0 0 8px rgba(150, 150, 150, .6);\n  display: none;\n  margin-top: 4px;\n  padding: 10px;\n  width: 240px;\n}\n\n.ui-datepicker a,\n.ui-datepicker a:hover {\n  text-decoration: none;\n}\n\n.ui-datepicker a:hover,\n.ui-datepicker td:hover a {\n  color: #e5bd54;\n  -webkit-transition: color 0.1s ease-in-out;\n  -moz-transition: color 0.1s ease-in-out;\n  -o-transition: color 0.1s ease-in-out;\n  transition: color 0.1s ease-in-out;\n}\n\n.ui-datepicker .ui-datepicker-header {\n  margin-bottom: 4px;\n  text-align: center;\n  border-radius: 4px;\n  padding: 2px;\n}\n\n.ui-datepicker .ui-datepicker-title {\n  font-weight: 700;\n}\n\n.ui-datepicker .ui-datepicker-prev,\n.ui-datepicker .ui-datepicker-next {\n  cursor: pointer;\n  -webkit-font-smoothing: antialiased;\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: normal;\n  height: 26px;\n  line-height: 1;\n  width: 30px;\n}\n\n.ui-datepicker .ui-datepicker-prev-hover:hover,\n.ui-datepicker .ui-datepicker-next-hover:hover{\n    border-radius: 4px;\n    background-color: #eee;\n  }\n\n.ui-datepicker .ui-datepicker-prev {\n  float: left;\n  text-align: left;\n  padding-left: 7px;\n}\n\n.ui-datepicker .ui-datepicker-next {\n  float: right;\n  text-align: right;\n  padding-right: 7px;\n}\n\n.ui-datepicker .ui-icon {\n  display: none;\n}\n\n.ui-datepicker .ui-datepicker-calendar {\n  table-layout: fixed;\n  width: 100%;\n}\n\n.ui-datepicker .ui-datepicker-calendar th,\n.ui-datepicker .ui-datepicker-calendar td {\n  text-align: center;\n  padding: 4px 0;\n}\n\n.ui-datepicker .ui-datepicker-calendar td {\n  border-radius: 4px;\n  -webkit-transition: background-color 0.1s ease-in-out, color 0.1s ease-in-out;\n  -moz-transition: background-color 0.1s ease-in-out, color 0.1s ease-in-out;\n  -o-transition: background-color 0.1s ease-in-out, color 0.1s ease-in-out;\n  transition: background-color 0.1s ease-in-out, color 0.1s ease-in-out;\n}\n\n.ui-datepicker .ui-datepicker-calendar td:hover {\n  background-color: #eee;\n  cursor: pointer;\n}\n\n.ui-datepicker .ui-datepicker-calendar td a {\n  text-decoration: none;\n}\n\n.ui-datepicker .ui-datepicker-current-day {\n  background-color: #e5bd54;\n}\n\n.ui-datepicker .ui-datepicker-current-day a {\n  color: #fff;\n}\n\n\n.ui-datepicker .ui-datepicker-calendar .ui-datepicker-unselectable {\n  background-color: #eff0f1;\n  cursor: default;\n}\n\n.ui-datepicker .ui-datepicker-calendar .ui-datepicker-unselectable:hover {\n  background-color: #eff0f1;\n  cursor: default;\n}\n\n\n.ui-datepicker-prev span {\n  display: none;\n}\n\n.ui-datepicker-prev::before {\n  display: inline-block;\n  content: \"\";\n  background-image: url(\"data:image/svg+xml,%3Csvg width='1em' height='1em' viewBox='0 0 16 16' class='bi bi-caret-left-fill' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.86 8.753l5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-size: 1rem 1.5rem;\n  width: 1rem;\n  height: 1.7rem;\n}\n\n.ui-datepicker-next::after {\n  display: inline-block !important;\n  content: \"\";\n  background-image: url(\"data:image/svg+xml,%3Csvg width='1em' height='1em' viewBox='0 0 16 16' class='bi bi-caret-right-fill' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-size: 1rem 1.5rem;\n  width: 1rem;\n  height: 1.7rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
